import { useEffect, useState, useMemo } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { getMaxQuantityByVariant } from 'libs/cart'

function useInCart(currentVariant) {
  const [cartItems, setCartItems] = useState(GM_STATE.cart.initCart?.items || [])
  const [maxVariantQuantity, setMaxVariantQuantity] = useState(currentVariant?.inventory_quantity || 0)

  const isAvailable = useMemo(() => maxVariantQuantity > 0, [maxVariantQuantity])

  const syncMaxQuantity = (items, variant) => {
    const max = getMaxQuantityByVariant(items, variant)
    setMaxVariantQuantity(max)
  }

  useEffect(() => {
    globalEmitter.on(emitterProps.cart.update, (items) => {
      setCartItems(items)
      syncMaxQuantity(items, currentVariant)
    })
  }, [])

  useEffect(() => {
    syncMaxQuantity(cartItems, currentVariant)
  }, [currentVariant])

  return { maxVariantQuantity, isAvailable }
}

export default useInCart
